import { CommonModule } from '@angular/common';
import { Component, computed, input, signal, EventEmitter, Output, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';
import { ThaidatePipe } from '../../pipe/thaidate-pipe';
import moment from 'moment';
import { TranslateModule } from '../../shareds/translate/translate.module';
type UpdateDatePayload = { inDate: string; outDate: string };
@Component({
  selector: 'app-checkin',
  imports: [CommonModule,
    FormsModule,
    DatePicker,
    ThaidatePipe,
    TranslateModule],
  templateUrl: './checkin.component.html',
  styleUrls: ['./checkin.component.scss']
})
export class CheckinComponent {
  dateRange: Date[] = [];
  dateRangeSig = signal<Date[] | null>(null);
  @Input('inputDate') set value(v: any) {
    const d0 = v?.[0] ? new Date(v[0]) : null;
    const d1 = v?.[1] ? new Date(v[1]) : null;
    const valid0 = d0 && !isNaN(d0.getTime());
    const valid1 = d1 && !isNaN(d1.getTime());
    this.dateRange = valid0 ? (valid1 ? [d0, d1] : [d0]) : [];
    this.dateRangeSig.set(this.dateRange.length > 0 ? [...this.dateRange] : null);
  }
  @Output('updateDate') updateDateChange = new EventEmitter<any>();
  constructor() {

  }


  calcNights(range: Date[] | null): number {
    if (!range?.[0] || !range?.[1]) return 0;

    const start = new Date(range[0]); start.setHours(0, 0, 0, 0);
    const end = new Date(range[1]); end.setHours(0, 0, 0, 0);

    const ms = end.getTime() - start.getTime();
    return Math.max(0, Math.round(ms / 86400000));
  }

  nights = computed(() => {
    const r = this.dateRangeSig();
    if (!r?.[0] || !r?.[1]) return 0;

    const start = new Date(r[0]); start.setHours(0, 0, 0, 0);
    const end = new Date(r[1]); end.setHours(0, 0, 0, 0);

    const diffDays = Math.round((end.getTime() - start.getTime()) / 86400000);
    return Math.max(0, diffDays);
  });

  updateDate() {
    this.dateRangeSig.set(this.dateRange ? [...this.dateRange] : null);
    // this.nights = this.calcNights(this.dateRange);
  }

  submit() {
    if (this.nights() === 0) {

    } else this.updateDateChange.emit({ status: 'update', inDate: moment(this.dateRange[0]).format('YYYY-MM-DD') ?? null, outDate: moment(this.dateRange[1]).format('YYYY-MM-DD') ?? null })

  }

  toBack() {
    this.updateDateChange.emit({ status: 'back' })
  }
}
